<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h5>Find Content</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5" style="padding-top:10px;">
        <vue-autosuggest
          v-if="hashtagProps !=null"
          v-model="hashtagSearchField"
          :suggestions="hashtagList"
          @input="loadHashtags"
          @selected="setHashtagSearch"
          :get-suggestion-value="setHashtagValue"
          :input-props="hashtagProps"
        ></vue-autosuggest>
      </div>
      <div class="col-md-5">
        <p-button @click="hashtagSearch">Search</p-button>
      </div>
    </div>

    <div v-if="postList !== null">
      <hr />

      <div class="row">
        <div class="col-md-5">
          <h4 style="margin-top:5px; margin-left:10px;">Results for @{{$route.query.q}}</h4>
          <p style="padding-left:15px;">{{postList.length}} results</p>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6 col-lg-3" v-for="post in postList" :key="post.shortcode">
          <div class="hovereffect post-click" @click="showPostModal(post.shortcode)">
            <span style="width:100%">
              <img :src="post.displayUrl" alt class="img-responsive" />
            </span>
            <div class="overlay">
              <div class="overlay-stats">
                <div style="padding:15px;">
                  <i v-if="post.type=='GraphSidecar'" class="fas fa-photo-video"></i>
                  <i v-if="post.type=='GraphImage'" class="far fa-image"></i>
                  <i v-if="post.type=='GraphVideo'" class="fas fa-video"></i>
                </div>
                <p v-if="post.type=='GraphVideo'">views: {{post.viewCountString}}</p>
                <p>likes: {{post.likeCountString}}</p>
                <p>comments: {{post.commentCountString}}</p>

                <p class="icon-links">
                  <p-button type="info" @click="navigateDownload(post.shortcode)" round>Download</p-button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row" v-if="searchData.hashtags.length > 0">
        <div class="col-md-12">
          <p>Browse Related Hashtags:</p>
        </div>
        <div class="col-md-12">
          <div
            class="hashtag-badge"
            v-for="hashtag in searchData.hashtags"
            :key="hashtag.hashtag"
            @click="badgeSearch(hashtag.hashtag)"
          >
            <badge type="danger">{{hashtag.hashtag}} ({{hashtag.count}})</badge>
          </div>
        </div>
      </div>
    </div>
    <div v-if="searchActive== true">
      <p>Searching...</p>
    </div>
    <modal
      :show.sync="showPost"
      footer-classes="justify-content-center"
      close="closeModal"
      type="notice"
    >
      <h5 slot="header" style="display:none;" class="modal-title">How Do You Become an Affiliate?</h5>
      <template>
        <div class="iframe-center">
          <iframe
            :src="`https://www.instagram.com/p/${postShortcode}/embed`"
            frameborder="0"
            scrolling="no"
            allowtransparency="true"
            v-if="postShortcode !=null"
            height="600px"
          ></iframe>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import _ from "underscore";
import { instagramContentSearchApi } from "@/config/appSettings";
import IgProfile from "@/libs/ig/profileData";
import { Badge, Modal } from "@/components/UIComponents";
import { mapGetters, mapActions } from "vuex";
import { VueAutosuggest } from "vue-autosuggest";
export default {
  components: {
    [Badge.name]: Badge,
    VueAutosuggest,
    Modal
  },
  data: () => ({
    auth: null,
    loadingOverlay: false,
    campaign: null,
    postList: null,
    visibleList: [],
    currentInstagram: null,
    campaigns: null,
    isInfluencer: null,
    isClient: null,
    searchData: null,
    hashtagList: [],
    searchHashtag: null,
    searchKeyword: null,
    searchQuery: null,
    searchField: null,
    hashtagProps: null,
    hashtagSearchField: null,
    searchActive: false,
    showPost: false,
    postShortcode: null,
    postEmbedCode: null
  }),
  name: "InfluencerPostList",
  methods: {
    async setHashtagValue(val) {
      return val.name;
    },
    async navigateDownload(shortcode) {
      this.showPost = false;
      this.$router.push("/instagram/download/" + shortcode);
    },
    async closeModal(val) {
      this.showPost = false;
      this.postShortcode = null;
      this.postEmbedCode = null;
      console.log("CLOSING...");
    },
    async badgeSearch(hashtag) {
      this.postList = null;
      this.$router.push(`/instagram/search/content?q=${hashtag}`);
      await this.loadPosts();
    },
    async hashtagSearch() {
      console.log("SEARCH FIELD", this.hashtagSearchField);
      this.postList = null;
      this.$router.push(
        `/instagram/search/content?q=${this.hashtagSearchField}`
      );
      await this.loadPosts();
    },
    async setHashtagSearch(input) {
      console.log("ITEM:", input.item);
      if (typeof input !== "undefined" && input !== null) {
        this.hashtagSearchField = input.item;

        return;
      }
      if (this.hashtagSearchField !== null) {
        return;
      }
    },
    async loadHashtags(val) {
      try {
        //console.log("QUERY:", val);
        if (typeof val !== "undefined") {
          let hastagResponse = await axios.get(
            `https://www.instagram.com/web/search/topsearch/?context=hashtag&query=${val}`
          );
          //console.log("CHECKING LOCATIONS:", locationResponse.data);
          let emoji = /([#0-9]\u20E3)|[\xA9\xAE\u203C\u2047-\u2049\u2122\u2139\u3030\u303D\u3297\u3299][\uFE00-\uFEFF]?|[\u2190-\u21FF][\uFE00-\uFEFF]?|[\u2300-\u23FF][\uFE00-\uFEFF]?|[\u2460-\u24FF][\uFE00-\uFEFF]?|[\u25A0-\u25FF][\uFE00-\uFEFF]?|[\u2600-\u27BF][\uFE00-\uFEFF]?|[\u2900-\u297F][\uFE00-\uFEFF]?|[\u2B00-\u2BF0][\uFE00-\uFEFF]?|(?:\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF])[\uFE00-\uFEFF]?|[\u20E3]|[\u26A0-\u3000]|\uD83E[\udd00-\uddff]|[\u00A0-\u269F]/g;

          let cleanHashtags = hastagResponse.data.hashtags.map(x => {
            /*return {
                    name: x.hashtag.name,
                    nameString: `${x.hashtag.name}`
                  };*/
            if (x.hashtag.name.match(emoji)) {
              return [];
            }
            if (
              x.hashtag.name.match(
                /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g
              )
            ) {
              return [];
            }
            return x.hashtag.name;
          });

          cleanHashtags = _.flatten(cleanHashtags);
          cleanHashtags = _.unique(cleanHashtags);

          this.hashtagList = [
            {
              data: cleanHashtags
            }
          ];
          return this.hashtagList;
          //console.log("HASHTAG LIST:", this.hashtagList);
        }
        if (typeof this.$route.query.q !== "undefined") {
          let hastagResponse = await axios.get(
            `https://www.instagram.com/web/search/topsearch/?context=hashtag&query=${this.$route.query.q}`
          );
          //console.log("CHECKING LOCATIONS:", locationResponse.data);
          // SPLIT HASHTAG LIST
          let emoji = /([#0-9]\u20E3)|[\xA9\xAE\u203C\u2047-\u2049\u2122\u2139\u3030\u303D\u3297\u3299][\uFE00-\uFEFF]?|[\u2190-\u21FF][\uFE00-\uFEFF]?|[\u2300-\u23FF][\uFE00-\uFEFF]?|[\u2460-\u24FF][\uFE00-\uFEFF]?|[\u25A0-\u25FF][\uFE00-\uFEFF]?|[\u2600-\u27BF][\uFE00-\uFEFF]?|[\u2900-\u297F][\uFE00-\uFEFF]?|[\u2B00-\u2BF0][\uFE00-\uFEFF]?|(?:\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF])[\uFE00-\uFEFF]?|[\u20E3]|[\u26A0-\u3000]|\uD83E[\udd00-\uddff]|[\u00A0-\u269F]/g;

          let cleanHashtags = hastagResponse.data.hashtags.map(x => {
            /*return {
                    name: x.hashtag.name,
                    nameString: `${x.hashtag.name}`
                  };*/
            if (x.hashtag.name.match(emoji)) {
              return [];
            }
            if (
              x.hashtag.name.match(
                /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g
              )
            ) {
              return [];
            }
            return x.hashtag.name;
          });

          cleanHashtags = _.flatten(cleanHashtags);
          cleanHashtags = _.unique(cleanHashtags);

          this.hashtagList = [
            {
              data: cleanHashtags
            }
          ];
          //console.log("HASHTAG LIST:", this.hashtagList);

          return this.hashtagList;
        }
        return this.hashtagList;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
        this.hashtagList = [
          {
            data: []
          }
        ];
        return this.hashtagList;
      }
    },
    async loadPosts() {
      try {
        if (typeof this.$route.query.q !== "undefined") {
          this.searchActive = true;
          this.hashtagSearchField = this.$route.query.q;
          let contentSearchUrl = `${instagramContentSearchApi}/?usertoken=${this.auth}&hashtag=${this.$route.query.q}`;
          console.log("HERE IS THE MENTION POST URL: ", contentSearchUrl);
          let contentSearchResponse = await axios.get(contentSearchUrl);
          console.log(contentSearchResponse.data);
          if (contentSearchResponse.data.success == true) {
            this.postList = contentSearchResponse.data.result;
            this.searchData = contentSearchResponse.data;
            this.searchActive = false;
          }

          return;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async showPostModal(shortcode) {
      let postEmbedResponse = await axios.get(
        `https://api.instagram.com/oembed/?url=https://www.instagram.com/p/${shortcode}/&omitscript=true`
      );
      //console.log("POST CODE:", postEmbedResponse.data.html);
      if (typeof postEmbedResponse.data.html !== "undefined") {
        this.postEmbedCode = postEmbedResponse.data.html;
        this.showPost = true;
        this.postShortcode = shortcode;
      }
    },

    async loadPageContent() {
      //await this.loadCampaignDetails();
      if (typeof this.$route.query.q !== "undefined") {
        await this.loadPosts();
      }
    }
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();

    this.hashtagProps = {
      id: "autosuggest__input",
      onInputChange: this.loadHashtags,
      placeholder: "Search by Hashtag"
    };
  }
};
</script>

<style scoped>
.post-item {
  float: left;
  padding: 10px;
  height: 250px;
  width: 250px;
  overflow: hidden;
  cursor: pointer !important;
}
.overlay p {
  color: white;
}
.overlay i {
  font-size: 40px;
  color: white;
}
.overlay-stats {
  margin: 0;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.iframe-center {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  width: 300px;
}
.hashtag-badge {
  margin: 3px;
  float: left;
}
.hashtag-badge :hover {
  cursor: pointer;
}
.post-click {
  cursor: pointer;
}
html {
  overflow-y: scroll !important;
}
</style>